export const TASK_STATUS_OPTIONS = [
	{ value: "ToDo", label: "To do" },
	{ value: "InProgress", label: "In Progress" },
	{ value: "Done", label: "Done" },
	{ value: "Cancelled", label: "Cancelled" },
];

const LEGACY_STATUS_MAP = {
	Planned: "ToDo",
	Dispatched: "ToDo",
};

const LABELS = TASK_STATUS_OPTIONS.reduce((acc, { value, label }) => {
	acc[value] = label;
	return acc;
}, {});

/** Map stored/API status to a form select value. */
export const normalizeTaskStatus = (status) => {
	if (!status) return "ToDo";
	if (LEGACY_STATUS_MAP[status]) return LEGACY_STATUS_MAP[status];
	if (LABELS[status]) return status;
	return "ToDo";
};

/** Human-readable label for chips and calendar. */
export const getTaskStatusLabel = (status) => {
	const normalized = normalizeTaskStatus(status);
	return LABELS[normalized] || status || "To do";
};

export const DEFAULT_TASK_STATUS = "ToDo";

/** List display order: active work first, then completed/cancelled. */
const TASK_STATUS_SORT_ORDER = ["InProgress", "ToDo", "Done", "Cancelled"];

export const getTaskStatusSortIndex = (status) => {
	const normalized = normalizeTaskStatus(status);
	const index = TASK_STATUS_SORT_ORDER.indexOf(normalized);
	return index === -1 ? TASK_STATUS_SORT_ORDER.length : index;
};

export const isTaskActive = (status) => {
	const normalized = normalizeTaskStatus(status);
	return normalized !== "Done" && normalized !== "Cancelled";
};
